const stripe = document.getElementById('stripe') as HTMLElement

export const showStripe = () => (stripe.style.display = 'block')
export const hideStripe = () => {
  stripe.style.removeProperty('display')
  stripe.innerHTML = ''
}

export const initCloseStripeButton = (close: () => void) => {
  const closeStripeButton = document.createElement('div')
  closeStripeButton.style.position = 'absolute'
  closeStripeButton.style.top = '20px'
  closeStripeButton.style.right = '20px'
  closeStripeButton.style.fontWeight = 'bold'
  closeStripeButton.style.fontSize = '30px'
  closeStripeButton.style.lineHeight = '30px'
  closeStripeButton.style.color = '#000000'
  closeStripeButton.innerText = '✕'
  closeStripeButton.className = 'clickable'
  closeStripeButton.onclick = close
  stripe.appendChild(closeStripeButton)
  return closeStripeButton
}
